module.exports = __webpack_public_path__ + "img/game-card-profile-icon.9f209f6a.png";